<template>
  <div id="app">
    <router-view v-if="isRouterAlive" />
  </div>
</template>
<script>
export default {
  name: "app",
  metaInfo() {
    return {
      title: this.seo_title,
      meta: [
        {
          name: "keywords",
          content: this.seo_keyword
        },
        {
          name: "description",
          content: this.seo_describe
        }
      ]
    };
  },
  provide() {
    return {
      reload: this.reload
    };
  },
  data() {
    return {
      isRouterAlive: true,
      seo_title: '',
      seo_keyword: '',
      seo_describe: ''
    };
  },
  watch: {
    $route() {
      this.setSeo();
    }
  },
  mounted() {
    this.setSeo();
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function() {
        this.isRouterAlive = true;
      });
    },
    setSeo() {
      this.post(this, "/home/getConfig", {}).then(res => {
        let meta1 = document.createElement("meta");
        let meta2 = document.createElement("meta");
        meta1.name = "Keywords";
        meta2.name = "Description";
        meta1.content = res.data.data.seo_keyword;
        meta2.content = res.data.data.seo_describe;
        document.head.appendChild(meta1);
        document.head.appendChild(meta2);

        setTimeout(() => {
          this.seo_keyword = res.data.data.seo_keyword;
          this.seo_describe = res.data.data.seo_describe;
          this.seo_title = res.data.data.seo_title;
        }, 1000);
      });
    }
  }
};
</script>

<style>
#app{
  min-width: 1200px;
}
</style>